'use strict';

angular.module('ClinicApp').directive('appointmentAvailabilityDetails', function(OCAppointmentUtil) {
  return {
    templateUrl: '/views/directives/_appointment-availability-details.html',
    scope: {
      appointment: '=',
    },

    link: function($scope) {

      $scope.patientHasAvailabilityPreference = function() {
        var overallAvailability = _.get($scope.appointment, 'requestData.availability.overall') || _.get($scope.appointment, 'match.other.availability');
        var specificAvailabilities = _.get($scope.appointment, 'requestData.availability.specific') || _.get($scope.appointment, 'match.other.specificAvailabilities') || [];

        if (!overallAvailability || overallAvailability == 'nopreference') {
          return false;
        } else if (overallAvailability == 'specify' && !specificAvailabilities.length) {
          return false;
        } else {
          return true;
        }
      };

      $scope.patientProvidedAvailabilityDetails = _.get($scope.appointment, 'requestData.availability.details') !== '' && _.get($scope.appointment, 'requestData.availability.details') !== undefined;
      $scope.availabilityDetails = $scope.patientProvidedAvailabilityDetails ? _.get($scope.appointment, 'requestData.availability.details') : 'Patient didn’t provide any suggested availability.';
      $scope.specificAvailabilities = _.get($scope.appointment, 'requestData.availability.specific') || _.get($scope.appointment, 'match.other.specificAvailabilities') || [];
      $scope.printedAvailabilitiesList = $scope.patientHasAvailabilityPreference ? OCAppointmentUtil.getPatientAvailabilityDisplay($scope.appointment) : 'Patient didn’t provide any preferences.';
      $scope.showAvailabilityPreferences = (
        $scope.patientProvidedAvailabilityDetails
        || $scope.patientHasAvailabilityPreference()
      );
      $scope.openAvailabilityPreferences = true;

      $scope.toggleAvailabilityPreferences = function() {
        $scope.openAvailabilityPreferences = !$scope.openAvailabilityPreferences;
      };
    },
  };
});
